<template>
<el-row v-if="isShow">
    <div class="page-back-left">
    <el-button type="" class="back-btn" @click="goBack()"  icon="el-icon-back" size="medium">
        返回
    </el-button>
    </div>
    <div class="page-back-right">
        <el-button type="" circle @click="refresh" icon="el-icon-refresh-right" size="medium">
    </el-button>
    </div>
</el-row>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    goBack() {
      if(this.$route.name == 'editCompany') {
        this.$router.push({
          path: `/company`
        })
      }else if(this.$route.name == 'editApi') {
        this.$router.push({
          path: `/merchant`
        })
      }else if(this.$route.name == 'editChannel'){
        this.$router.push({
          path: `/channel`
        })
      }else {
        this.$router.go(-1)
      }
    },
    refresh() {
      this.$router.go(0)
    }
  },
}
</script>

<style lang="stylus" scoped>
.page-back-left
  float left
.page-back-right
  float right
</style>